import { Controller } from "@hotwired/stimulus"

// Submits the form as soon as a field changes. Fields inside an element marked
// `data-autosubmit-paused` (e.g. an open side menu of filters) wait for an
// explicit submit instead.
export default class extends Controller {
  submit(event) {
    if (event?.target?.closest?.("[data-autosubmit-paused]")) return

    this.element.requestSubmit()
  }
}
